// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__n59fX"};